import React from 'react';
import './global.css';

const NAV_ITEMS = [
    { key: 'Home',          href: '/record-phone-calls-on-iphone-or-android',                                    label: 'Home'     },
    { key: 'UserGuide',     href: '/call-recorder-and-transcriber-user-guide',                                   label: 'Tutorial' },
    { key: 'Pricing',       href: '/how-much-does-it-cost-to-record-and-transcribe-phone-call-conversation',     label: 'Pricing'  },
    { key: 'TermsOfUse',    href: '/call-recorder-and-transcriber-terms-of-use',                                 label: 'Terms'    },
    { key: 'PrivacyPolicy', href: '/call-recorder-and-transcriber-privacy-policy',                               label: 'Privacy'  },
    { key: 'FAQ',           href: '/call-recorder-and-transcriber-frequently-asked-questions',                   label: 'FAQ'      },
    { key: 'ContactUs',     href: '/answer-solutions-contact',                                                   label: 'Support'  },
    { key: 'About',         href: '/about-answer-solutions',                                                     label: 'About'    },
];

function NavBar({ navigate, current }) {
    return (
        <div className="card" id="shellPrimaryNoPadding">
            <div className="top_menu containerNoMargin">
                <ul>
                    {NAV_ITEMS.map(item => (
                        <li key={item.key} className={current === item.key ? 'first' : ''}>
                            <a href={item.href} role="button" onClick={() => navigate(item.key)}> {item.label} </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default NavBar;
